function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2.5000012mm",
    height: "2.500001mm",
    viewBox: "0 0 2.5000012 2.500001",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.0795639,-19.566003)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.6192414)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000000",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    cx: 5.9488058,
    cy: 20.816004,
    r: 0.75000054
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.29013dc22c69b5f7903de4c37b40dd30.svg";
export { ForwardRef as ReactComponent };